import { MenuItemProps, default as MuiMenuItem } from '@mui/material/MenuItem'

export const MenuItem = (props: MenuItemProps) => {
  return <MuiMenuItem {...props} />
}

export default MenuItem
